import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import Select from 'react-select';
import { useStores } from './stores/useStores';

function InsectGroupSelect(props) {
  const { traplogStore } = useStores();

  // Filter out all insects except those specified in
  // "props.customInsects", if it exists.
  const customInsects = props.customInsects;
  const insectGroups = customInsects
    ? traplogStore.insectGroups.filter((value) =>
        customInsects.includes(value.short_name)
      )
    : traplogStore.insectGroups;
  const options = insectGroups.map((insectGroup) => {
    return {
      value: insectGroup.id,
      label: insectGroup.name
    };
  });
  // Select "Codling Moth" if custom insect groups are given
  // and it specifies the Codling Moth group.
  if (
    insectGroups.length > 0 &&
    customInsects &&
    customInsects.includes('CM') &&
    traplogStore.selectedInsectGroupId === null
  ) {
    traplogStore.setSelectedInsectGroupId(
      props.bearerToken,
      props.refreshBearerToken,
      props.selectedDatabase,
      insectGroups.find((ig) => ig.short_name === 'CM').id
    );
  }

  return (
    <Select
      placeholder='Select an insect'
      isLoading={traplogStore.loadingInsectGroups}
      options={options}
      value={
        traplogStore.selectedInsectGroup
          ? {
              value: traplogStore.selectedInsectGroup.id,
              label: traplogStore.selectedInsectGroup.name
            }
          : null
      }
      onChange={(option) => {
        if (traplogStore.selectedInsectGroupId === option.value) return;
        traplogStore.resetAllTrappingZoneHighPressure();
        traplogStore.setSelectedInsectGroupId(
          props.bearerToken,
          props.refreshBearerToken,
          props.selectedDatabase,
          option.value
        );
      }}
    />
  );
}

InsectGroupSelect.propTypes = {
  selectedDatabase: PropTypes.string,
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,
  customInsects: PropTypes.array
};

export default observer(InsectGroupSelect);
